module.exports = __webpack_public_path__ + "img/77df40d018bc478b9e241fa050408e93.cbfd257e.png";